/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import styles from '../../../../styles';
import Localized from '../../../../../shared/components/Localized';

import AllSeverityGrid from '../AllSeverityGrid';

const Wrapper = styled.div`
  background-color: white;
  padding: 2rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const Value = styled.div`
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;

const Grid = styled.div`
  margin-top: 1rem;
`;

class AllSeverityPage extends React.Component {
  render() {
    return (
      <Wrapper>
        <Label>
          <Localized
            modelKey='product'
            modelAttribute='header'
            modelName='product' />:
        </Label>
        <Value>
          <Localized
            modelKey={ this.props.instanceKey }
            modelAttribute='label'
            modelName='product' />
        </Value>
        <Grid>
          <Label>
            Select Services and Severities
          </Label>
          <AllSeverityGrid
            severityGrid={this.props.severityGrid}
          />
        </Grid>
      </Wrapper>
    );
  }
}

export default AllSeverityPage;
